<template>
    <div class="about_menu_top  textalign_left">
        <div style="background-color: #B43728;max-width: 1920px;margin: 0 auto;"  class="ms-controller">
            <div style="margin: 0 auto;">
                <div style="height: 10069px;background: url('http://p1.fishqc.net/FvyakAS5RQ8BnOWptH1RTmRDW8rn') center center no-repeat;background-size: auto 100%;">
                    <div style="width:1000px;margin:0 auto;display:block;position: relative;font-size:36px;font-family:PingFang SC;color:#533727;text-align: center;padding-top: 440px;box-sizing: border-box;font-size: 0">
                        <div>
                            <div class="desc1 totaldesc" style="margin:80px auto 26px;text-align: center;">
                                2020年就要过去了，经历了看似不怎么平静的一年，<br>我们学会更加珍惜自己的生命。<br>跟着优品指南好好跨年，<br>等待我们的，是崭新美好的2021年。
                            </div>
                            <div>
                                <img src="http://p1.fishqc.net/Fto3wPSisA_x49YFo21omvO2rPA9" alt="">
                            </div>
                            <div style="padding-top: 22px;box-sizing: border-box;">
                                <img src="http://p1.fishqc.net/FqS9rjwvvKQHoSZkFKCWVfa8znlx" alt="">
                            </div>
                            <div class="desc1" style="margin:25px auto 46px;">
                                跨年夜，要酷要潮更要成为别人镜头里的追焦风景，完美肌肤，精
                                致妆容，独特发色全都有，新的一年够美。
                            </div>
                            <div class="padding_bottom_25">
                                <img src="http://p1.fishqc.net/FrUKbTauFuOf2kqFD45-zWTaJgsJ" alt="">
                            </div>
                            <div style="position: relative;width:1000px;margin:0 auto;">
                                <div class="box1 display_flex flex-direction_column justify-content_flex-justify ">
                                    <div class="box_title">
                                        皮肤每分每秒都在被氧化，同时也在老化，保持年轻肌肤，抗氧化很重
                                        要。精华可渗入基底层发挥作用，跟着小鱼选择抗氧化功效显著产品，
                                        事半功倍。
                                    </div>
                                    <div class="display_flex justify-content_flex-justify ">
                                        <div class="innerbox display_flex justify-content_flex-justify" @click="toproductdetail('cosmetic','75gedO8xHckPs-bj5iiVpQ')">
                                            <div class="product_left" style="background-image: url('http://p1.fishqc.net/Fg7OTcaTawSFEb9gtsAlUlQPD9bm');background-size: 44px 133px;">
                                                <img src="http://p1.fishqc.net/Foalqxp6R214JD3grMIOi1iXt4Aw" style="width: 129px;position: absolute;bottom:22px;left: 12px">
                                            </div>
                                            <div class="product_right display_flex flex-direction_column  align-items_space_between">
                                                <div>
                                                    <div>
                                                        VAQUA活泉
                                                    </div>
                                                    <div>
                                                        樱花胜肽抗初老青春精华液
                                                    </div>
                                                </div>
                                                <div class="display_flex justify-content_flex-justify align-items_flex-end" style="padding-top: 18px;box-sizing: border-box;">
                                                    <div class="address">品牌所在地：中国</div>
                                                    <div class="label">抗衰必备</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="innerbox display_flex justify-content_flex-justify" @click="toproductdetail('cosmetic','AW3JRiC08AeSf6ADTPdMGQ')">
                                            <div class="product_left" style="background-image: url('http://p1.fishqc.net/FqcgP6LVMVif3UtTVL56Ok9ZqTWk');background-size: 32px 133px;">
                                                <img src="http://p1.fishqc.net/Foalqxp6R214JD3grMIOi1iXt4Aw" style="width: 129px;position: absolute;bottom:22px;left: 12px">
                                            </div>
                                            <div class="product_right display_flex flex-direction_column  align-items_space_between">
                                                <div>
                                                    <div>
                                                        NIVEA妮维雅
                                                    </div>
                                                    <div>
                                                        细胞激活抗皱紧致精华乳霜
                                                    </div>
                                                </div>
                                                <div class="display_flex justify-content_flex-justify align-items_flex-end" style="padding-top: 18px;box-sizing: border-box;">
                                                    <div class="address">品牌所在地：德国</div>
                                                    <div class="label">肌肤紧致</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="left_bg"></div>
                                <div class="right_bg"></div> -->
                            </div>
                            <div class="title_padding">
                                <img src="http://p1.fishqc.net/FiPyCCfjBi4jkyOIs32Me3w5EndP" alt="">
                            </div>
                            <div style="position: relative;width:1000px;margin:0 auto;">
                                <div class="box2 display_flex flex-direction_column justify-content_flex-justify">
                                    <div class="box_title">
                                        粉底液既可隔离彩妆对皮肤的伤害，又能调均肤色，让妆容更自然。劣
                                        质粉底液使用感差伤害皮肤，严重的可能使人体重金属中毒，选择安全
                                        的粉底液极其重要。
                                    </div>
                                    <div class="display_flex justify-content_flex-justify ">
                                        <div class="innerbox display_flex justify-content_flex-justify" @click="toproductdetail('cosmetic','wYJZj1oFh_oktdJKa_FXWA')">
                                            <div class="product_left" style="background-image: url('http://p1.fishqc.net/FmZBte6p2f5xjfDEWRsxSB_a0rO7');background-size: 51px 132px;">
                                                <img src="http://p1.fishqc.net/FgKglVB1x5X1JBzBtbBPfrTE9ChK" style="width: 65px;position: absolute;bottom:8px;right: 12px">
                                            </div>
                                            <div class="product_right display_flex flex-direction_column  align-items_space_between">
                                                <div>
                                                    <div>
                                                        DIOR迪奥 Forever
                                                    </div>
                                                    <div>
                                                        锁妆粉底液 哑光妆效 1N
                                                    </div>
                                                </div>
                                                <div class="display_flex justify-content_flex-justify align-items_flex-end" style="padding-top: 18px;box-sizing: border-box;">
                                                    <div class="address">品牌所在地：法国</div>
                                                    <div class="label">超长持妆</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="innerbox display_flex justify-content_flex-justify" @click="toproductdetail('cosmetic','O1qfsawhU3JcIwxxyoUL7Q')">
                                            <div class="product_left" style="background-image: url('http://p1.fishqc.net/Fp_jcR3ibufECWh_GE-NR80vTtfc');background-size: 52px 132px;">
                                                <img src="http://p1.fishqc.net/FgKglVB1x5X1JBzBtbBPfrTE9ChK" style="width: 65px;position: absolute;bottom:8px;right: 12px">
                                            </div>
                                            <div class="product_right display_flex flex-direction_column  align-items_space_between">
                                                <div>
                                                    <div>
                                                        CLE DE PEAU BEAUTE
                                                    </div>
                                                    <div>
                                                        肌肤之钥
                                                        光缎粉底霜
                                                    </div>
                                                </div>
                                                <div class="display_flex justify-content_flex-justify align-items_flex-end" style="padding-top: 18px;box-sizing: border-box;">
                                                    <div class="address">品牌所在地：日本</div>
                                                    <div class="label">水润透亮</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="left_bg1"></div>
                                <div class="right_bg1"></div> -->
                            </div>
                            <div class="title_padding" style="padding-bottom: 38px;">
                                <img src="http://p1.fishqc.net/FvXDsMGaan7v7Ld0Fck0ROIK2281" alt="">
                            </div>
                            <div style="position: relative;width:1000px;margin:0 auto;">
                                <div class="box3 display_flex flex-direction_column justify-content_flex-justify">
                                    <div class="box_title">
                                        不同的发色有不同的美感，好看的发色更让人心情愉悦。劣质染发剂容
                                        易产生脱发过敏，部分还可能有超标重金属或致癌物。选择绿鱼产品，
                                        要好看更要安全。
                                    </div>
                                    <div class="display_flex justify-content_flex-justify ">
                                        <div class="innerbox display_flex justify-content_flex-justify" @click="toproductdetail('cosmetic','k_dmbGffQ3v2ku_c5HVd3g')">
                                            <div class="product_left" style="background-image: url('http://p1.fishqc.net/FktqLhdf8C3ADg_71-BQlBFm8Gd0');background-size: 93px 129px;">
                                                <img src="http://p1.fishqc.net/FgKglVB1x5X1JBzBtbBPfrTE9ChK" style="width: 65px;position: absolute;bottom:8px;right: 12px">
                                            </div>
                                            <div class="product_right display_flex flex-direction_column  align-items_space_between">
                                                <div>
                                                    <div>
                                                        SALON DE PRO黛莉亚
                                                    </div>
                                                    <div>
                                                        沙龙级白发染发乳
                                                    </div>
                                                </div>
                                                <div class="display_flex justify-content_flex-justify align-items_flex-end" style="padding-top: 18px;box-sizing: border-box;">
                                                    <div class="address">品牌所在地：日本</div>
                                                    <div class="label">锁色持久</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="innerbox display_flex justify-content_flex-justify" @click="toproductdetail('cosmetic','EEl51gKfS_MD90ZEnmTrHw')">
                                            <div class="product_left" style="background-image: url('http://p1.fishqc.net/FmAJSBpN7Pb13JUIPYdB2R_wNlPY');background-size: 66px 131px;">
                                                <img src="http://p1.fishqc.net/FgKglVB1x5X1JBzBtbBPfrTE9ChK" style="width: 65px;position: absolute;bottom:8px;right: 12px">
                                            </div>
                                            <div class="product_right display_flex flex-direction_column  align-items_space_between">
                                                <div>
                                                    <div>
                                                        RADICO
                                                    </div>
                                                    <div>
                                                        有机天然染发粉
                                                    </div>
                                                </div>
                                                <div class="display_flex justify-content_flex-justify align-items_flex-end" style="padding-top: 18px;box-sizing: border-box;">
                                                    <div class="address">品牌所在地：印度</div>
                                                    <div class="label">健康染发</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="left_bg2"></div>
                                <div class="right_bg2"></div> -->
                            </div>
                        </div>
                        <div>
                            <div style="padding-top: 64px;box-sizing: border-box;">
                                <img src="http://p1.fishqc.net/FqfyZ2s6EQmle_Fsi3w6mqSy-tYN" alt="" style="width: 100%;">
                            </div>
                            <div style="padding-top: 10px;box-sizing: border-box;">
                                <img src="http://p1.fishqc.net/Fr3HdhsgOPny9h83PoURi94RnnDV" alt="">
                            </div>
                            <div class="desc1" style="margin:22px auto 35px;">
                                跨年的方式有很多，关键在于彼此有爱的心，两个相爱的人腻在一
                                起，就是幸福满满的仪式感，新的一年够甜。
                            </div>
                            <div class="padding_bottom_25" style="padding-bottom: 30px;">
                                <img src="http://p1.fishqc.net/FhYCu4yXxdYSUi2-GWwUHtzSC_dm" alt="">
                            </div>
                            <div style="position: relative;width:1000px;margin:0 auto;">
                                <div class="box1 display_flex flex-direction_column justify-content_flex-justify">
                                    <div class="box_title">
                                        涂上口红，亲吻就有痕迹。劣质口红可能存在急性毒或慢性毒风险，容
                                        易诱发过敏甚至炎症，为了两个人的健康，跟着绿鱼优品榜单。
                                    </div>
                                    <div class="display_flex justify-content_flex-justify ">
                                        <div class="innerbox display_flex justify-content_flex-justify" @click="toproductdetail('cosmetic','c-HUVg883aRz2qCqj-i4Iw')">
                                            <div class="product_left" style="background-image: url('http://p1.fishqc.net/FiAfwycKCCLUeHsShwZxGaJKOxdi');background-size: 74px 131px;">
                                                <img src="http://p1.fishqc.net/FgKglVB1x5X1JBzBtbBPfrTE9ChK" style="width: 65px;position: absolute;bottom:8px;right: 12px">
                                            </div>
                                            <div class="product_right display_flex flex-direction_column  align-items_space_between">
                                                <div>
                                                    <div>
                                                        GIVENCHY纪梵希
                                                    </div>
                                                    <div>
                                                        高定香榭天鹅绒唇膏
                                                    </div>
                                                </div>
                                                <div class="display_flex justify-content_flex-justify align-items_flex-end" style="padding-top: 18px;box-sizing: border-box;">
                                                    <div class="address">品牌所在地：法国</div>
                                                    <div class="label">秋冬潮色</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="innerbox display_flex justify-content_flex-justify" @click="toproductdetail('cosmetic','F34a85TDmMIU57jVnAJI0Q')">
                                            <div class="product_left" style="background-image: url('http://p1.fishqc.net/FreNAw7i-QqNHAAiPdh9VfeQ11kf');background-size: 78px 131px;">
                                                <img src="http://p1.fishqc.net/FgKglVB1x5X1JBzBtbBPfrTE9ChK" style="width: 65px;position: absolute;bottom:8px;right: 12px">
                                            </div>
                                            <div class="product_right display_flex flex-direction_column  align-items_space_between">
                                                <div>
                                                    <div>
                                                        YVES SAINT LAURENT
                                                    </div>
                                                    <div>
                                                        圣罗兰 莹亮纯魅唇膏
                                                    </div>
                                                </div>
                                                <div class="display_flex justify-content_flex-justify align-items_flex-end" style="padding-top: 18px;box-sizing: border-box;">
                                                    <div class="address">品牌所在地：法国</div>
                                                    <div class="label">气质显色</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="left_bg"></div>
                                <div class="right_bg"></div> -->
                            </div>
                            <div class="title_padding">
                                <img src="http://p1.fishqc.net/FlatULuEL9YHMN3mCixqWnT9VCES" alt="">
                            </div>
                            <div style="position: relative;width:1000px;margin:0 auto;">
                                <div class="box2 display_flex flex-direction_column justify-content_flex-justify">
                                    <div class="box_title">
                                        情侣送礼首选的巧克力种类繁多，鱼龙混杂。劣质巧克力使用低质量的
                                        代可可脂或非食用原料，容易对身体造成负担。认准绿鱼巧克力，甜蜜
                                        加倍。
                                    </div>
                                    <div class="display_flex justify-content_flex-justify ">
                                        <div class="innerbox display_flex justify-content_flex-justify" @click="toproductdetail('food','Jd2jN-iFbKzSi6j7eJeM9g')">
                                            <div class="product_left" style="background-image: url('http://p1.fishqc.net/Fs6DkGnNqPc-_OjaeOtx4USwxVEb');background-size: 111px 52px">
                                                <img src="http://p1.fishqc.net/FgKglVB1x5X1JBzBtbBPfrTE9ChK" style="width: 65px;position: absolute;bottom:8px;right: 12px">
                                            </div>
                                            <div class="product_right display_flex flex-direction_column  align-items_space_between">
                                                <div>
                                                    <div>
                                                        明治
                                                    </div>
                                                    <div>
                                                        至尊特浓黑巧克力
                                                    </div>
                                                </div>
                                                <div class="display_flex justify-content_flex-justify align-items_flex-end" style="padding-top: 18px;box-sizing: border-box;">
                                                    <div class="address">品牌所在地：日本</div>
                                                    <div class="label">香醇可口</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="innerbox display_flex justify-content_flex-justify" @click="toproductdetail('food','_BgOajMaA1bBx0yePCHs2g')">
                                            <div class="product_left" style="background-image: url('http://p1.fishqc.net/FkNNRJh8sYYAjKBkHwoYCGDCbBLX');background-size: 105px 45px;">
                                                <img src="http://p1.fishqc.net/FgKglVB1x5X1JBzBtbBPfrTE9ChK" style="width: 65px;position: absolute;bottom:8px;right: 12px">
                                            </div>
                                            <div class="product_right display_flex flex-direction_column  align-items_space_between">
                                                <div>
                                                    <div>
                                                        WHITTAKER'S惠特克
                                                    </div>
                                                    <div>
                                                        蜂蜜牛奶巧克力
                                                    </div>
                                                </div>
                                                <div class="display_flex justify-content_flex-justify align-items_flex-end" style="padding-top: 18px;box-sizing: border-box;">
                                                    <div class="address">品牌所在地：新西兰</div>
                                                    <div class="label">甜蜜之选</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="left_bg1"></div>
                                <div class="right_bg1"></div> -->
                            </div>
                            <div class="title_padding" style="padding:96px 0 25px;">
                                <img src="http://p1.fishqc.net/FvaZ4N0U_IJAR2zaDsM8gHeI5lAS" alt="">
                            </div>
                            <div style="position: relative;width:1000px;margin:0 auto;">
                                <div class="box3 display_flex flex-direction_column justify-content_flex-justify">
                                    <div class="box_title">
                                        亲密用品更要慎重选择，劣质避孕套会给私密部位带来感染的风险，还
                                        可能导致妇科疾病影响身体健康。选择绿鱼品质产品，二人世界更加幸
                                        福。
                                    </div>
                                    <div class="display_flex justify-content_flex-justify ">
                                        <div class="innerbox display_flex justify-content_flex-justify" @click="toproductdetail('cosmetic','YjMl0HDnyL4wkspv3YUa3A')">
                                            <div class="product_left" style="background-image: url('http://p1.fishqc.net/FpEPH6vZD47ibckUVBzJksgq39EQ');background-size: 76px 126px;">
                                                <img src="http://p1.fishqc.net/FgKglVB1x5X1JBzBtbBPfrTE9ChK" style="width: 65px;position: absolute;bottom:8px;right: 12px">
                                            </div>
                                            <div class="product_right display_flex flex-direction_column  align-items_space_between">
                                                <div>
                                                    <div>
                                                        DUREX杜蕾斯
                                                    </div>
                                                    <div>
                                                        隐薄空气套避孕套
                                                    </div>
                                                </div>
                                                <div class="display_flex justify-content_flex-justify align-items_flex-end" style="padding-top: 18px;box-sizing: border-box;">
                                                    <div class="address">品牌所在地：英国</div>
                                                    <div class="label">经典优选</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="innerbox display_flex justify-content_flex-justify" @click="toproductdetail('cosmetic','PGbEqYy6xE41bF3QKHO1bw')">
                                            <div class="product_left" style="background-image: url('http://p1.fishqc.net/FrwoZjnsLTS0MtIWkS68zAcZogHv');background-size: 69px 132px">
                                                <img src="http://p1.fishqc.net/FgKglVB1x5X1JBzBtbBPfrTE9ChK" style="width: 65px;position: absolute;bottom:8px;right: 12px">
                                            </div>
                                            <div class="product_right display_flex flex-direction_column  align-items_space_between">
                                                <div>
                                                    <div>
                                                        OKAMOTO冈本
                                                    </div>
                                                    <div>
                                                        0.01水性聚氨酯避孕套
                                                    </div>
                                                </div>
                                                <div class="display_flex justify-content_flex-justify align-items_flex-end" style="padding-top: 18px;box-sizing: border-box;">
                                                    <div class="address">品牌所在地：日本</div>
                                                    <div class="label">人气热销</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="left_bg2"></div>
                                <div class="right_bg2"></div> -->
                            </div>
                        </div>
                    </div>
                    
                    
                    <div style="width:1000px;margin:0 auto;display:block;position: relative;font-size:36px;font-family:PingFang SC;color:#533727;text-align: center;padding-top: 0px;box-sizing: border-box;font-size: 0">
                        <div>
                            <div style="padding-top: 64px;box-sizing: border-box;">
                        <img src="http://p1.fishqc.net/Fvb-tH2_oTG_19GETmI65V5-EiAW" alt="" style="margin:0px auto 0;">
                    </div>
                            <div style="padding-top: 86px;box-sizing: border-box;">
                                <img src="http://p1.fishqc.net/FpLSOnm8dpmxFBWifXAenDyTqifm" alt="">
                            </div>
                            <div class="desc1">
                                在新年倒数的欢庆里，与父母畅谈家事，轻抚怀里安睡的孩子，身
                                旁的大狗安静趴着听着，新的一年够暖。
                            </div>
                            <div class="padding_bottom_25" style="    padding-bottom: 40px;">
                                <img src="http://p1.fishqc.net/FqIU65D5n7UBHvUpguKXvPbaNqid" alt="">
                            </div>
                            <div style="position: relative;width:1000px;margin:0 auto;">
                                <div class="box1 display_flex flex-direction_column justify-content_flex-justify">
                                    <div class="box_title">
                                        牛奶可补充蛋白质与钙，提升免疫力。但劣质奶的造假术层出不穷，不
                                        仅卫生和营养不达标，还可能添加各种有害物质，认准绿鱼，家人喝得
                                        放心。
                                    </div>
                                    <div class="display_flex justify-content_flex-justify ">
                                        <div class="innerbox display_flex justify-content_flex-justify" @click="toproductdetail('food','3oyhpZVSKU-pDEK4-CJQOw')">
                                            <div class="product_left" style="background-image: url('http://p1.fishqc.net/FgKubXJMPoBLTna9GHg48nUCXiLp');background-size: 87px 89px;">
                                                <img src="http://p1.fishqc.net/FgKglVB1x5X1JBzBtbBPfrTE9ChK" style="width: 65px;position: absolute;bottom:8px;right: 12px">
                                            </div>
                                            <div class="product_right display_flex flex-direction_column  align-items_space_between">
                                                <div>
                                                    <div>
                                                        KOWLOON DAIRY维记
                                                    </div>
                                                    <div>
                                                        100%鲜牛奶
                                                    </div>
                                                </div>
                                                <div class="display_flex justify-content_flex-justify align-items_flex-end" style="padding-top: 18px;box-sizing: border-box;">
                                                    <div class="address">品牌所在地：中国香港 </div>
                                                    <div class="label">品质新鲜</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="innerbox display_flex justify-content_flex-justify" @click="toproductdetail('food','pQebCJwARx4EOqAnTFSTDA')">
                                            <div class="product_left" style="background-image: url('http://p1.fishqc.net/Fgk_cOSIsZ2RA5kwIOBGjoNkL4TN');background-size: 56px 129px;">
                                                <img src="http://p1.fishqc.net/FgKglVB1x5X1JBzBtbBPfrTE9ChK" style="width: 65px;position: absolute;bottom:8px;right: 12px">
                                            </div>
                                            <div class="product_right display_flex flex-direction_column  align-items_space_between">
                                                <div>
                                                    <div>
                                                        BRIGHTDAILY光明
                                                    </div>
                                                    <div>
                                                        优+全脂纯牛奶
                                                    </div>
                                                </div>
                                                <div class="display_flex justify-content_flex-justify align-items_flex-end" style="padding-top: 18px;box-sizing: border-box;">
                                                    <div class="address">品牌所在地：中国</div>
                                                    <div class="label">优质营养</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="left_bg"></div>
                                <div class="right_bg"></div> -->
                            </div>
                            <div class="title_padding" style="padding-bottom: 30px;">
                                <img src="http://p1.fishqc.net/FhUQTxUbPIz6D9rqdpTbrnzblbNX" alt="">
                            </div>
                            <div style="position: relative;width:1000px;margin:0 auto;">
                                <div class="box2 display_flex flex-direction_column justify-content_flex-justify">
                                    <div class="box_title">
                                        疫情还没结束，不能放松警惕。但过度使用酒精搓手液会让皮肤变得干燥、过敏甚至可能引起接触性皮肤炎，保护家人健康，选择绿鱼搓手液。
                                    </div>
                                    <div class="display_flex justify-content_flex-justify ">
                                        <div class="innerbox display_flex justify-content_flex-justify" @click="toproductdetail('cosmetic','9EQtYzukJLHS-1w-XVX8Hg')">
                                            <div class="product_left" style="background-image: url('http://p1.fishqc.net/Ft2fHW72Zt7OhwRJBuUjGfHyfgmz');background-size: 55px 132px">
                                                <img src="http://p1.fishqc.net/FgKglVB1x5X1JBzBtbBPfrTE9ChK" style="width: 65px;position: absolute;bottom:8px;right: 12px">
                                            </div>
                                            <div class="product_right display_flex flex-direction_column  align-items_space_between">
                                                <div>
                                                    <div>
                                                        DETTOL滴露
                                                    </div>
                                                    <div>
                                                        酒精搓手液 芦荟
                                                    </div>
                                                </div>
                                                <div class="display_flex justify-content_flex-justify align-items_flex-end" style="padding-top: 18px;box-sizing: border-box;">
                                                    <div class="address">品牌所在地：英国</div>
                                                    <div class="label">清新芦荟</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="innerbox display_flex justify-content_flex-justify" @click="toproductdetail('cosmetic','0IlcPAK05oPOcV11V2sU6w')">
                                            <div class="product_left" style="background-image: url('http://p1.fishqc.net/FmgdvkdTn1hM02ZIr7iBMacBGT2N');background-size: 65px 130px;">
                                                <img src="http://p1.fishqc.net/FgKglVB1x5X1JBzBtbBPfrTE9ChK" style="width: 65px;position: absolute;bottom:8px;right: 12px">
                                            </div>
                                            <div class="product_right display_flex flex-direction_column  align-items_space_between">
                                                <div>
                                                    <div>
                                                        WALCH威露士
                                                    </div>
                                                    <div>
                                                        免洗洁手液
                                                    </div>
                                                </div>
                                                <div class="display_flex justify-content_flex-justify align-items_flex-end" style="padding-top: 18px;box-sizing: border-box;">
                                                    <div class="address">品牌所在地：中国</div>
                                                    <div class="label">高效速干</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="left_bg1"></div>
                                <div class="right_bg1"></div> -->
                            </div>
                            <div class="title_padding" style="padding-bottom: 30px;">
                                <img src="http://p1.fishqc.net/Fp8zB11b3ouwJBd0x4uzvY9yLiOE" alt="">
                            </div>
                            <div style="position: relative;width:1000px;margin:0 auto;">
                                <div class="box3 display_flex flex-direction_column justify-content_flex-justify">
                                    <div class="box_title">
                                        劣质狗粮影响消化系统，长期食用容易出现慢性疾病，肠胃炎等，严重
                                        还可能危害生命。跟着绿鱼榜单选，家里的一份子，必须吃好点。
                                    </div>
                                    <div class="display_flex justify-content_flex-justify ">
                                        <div class="innerbox display_flex justify-content_flex-justify" @click="toproductdetail('food','rHqaiPJLRK6c66GX51lIDQ')">
                                            <div class="product_left" style="background-image: url('http://p1.fishqc.net/Fn2aTv1HFBLcqmsN9cqbEF9zZcYd');background-size: 74px 121px;">
                                                <img src="http://p1.fishqc.net/FgKglVB1x5X1JBzBtbBPfrTE9ChK" style="width: 65px;position: absolute;bottom:8px;right: 12px">
                                            </div>
                                            <div class="product_right display_flex flex-direction_column  align-items_space_between">
                                                <div>
                                                    <div>
                                                        HILL'S希尔思
                                                    </div>
                                                    <div>
                                                        i/d消化道调理狗粮
                                                    </div>
                                                </div>
                                                <div class="display_flex justify-content_flex-justify align-items_flex-end" style="padding-top: 18px;box-sizing: border-box;">
                                                    <div class="address">品牌所在地：美国</div>
                                                    <div class="label">改善消化</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="innerbox display_flex justify-content_flex-justify" @click="toproductdetail('food','5KtdFRTDxzN8i9JdRoSiNA')">
                                            <div class="product_left" style="background-image: url('http://p1.fishqc.net/Ftfu38BO6AAqgyUyToTlO4aGLNDs');background-size: 76px 113px;">
                                                <img src="http://p1.fishqc.net/FgKglVB1x5X1JBzBtbBPfrTE9ChK" style="width: 65px;position: absolute;bottom:8px;right: 12px">
                                            </div>
                                            <div class="product_right display_flex flex-direction_column  align-items_space_between">
                                                <div>
                                                    <div>
                                                        CANIDAE卡比
                                                    </div>
                                                    <div style="line-height: 22px;">
                                                        全阶营养系列鸡肉火鸡肉羊鱼
                                                        配方全犬粮
                                                    </div>
                                                </div>
                                                <div class="display_flex justify-content_flex-justify align-items_flex-end" style="padding-top: 8px;box-sizing: border-box;">
                                                    <div class="address">品牌所在地：美国</div>
                                                    <div class="label">营养均衡</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="left_bg2"></div>
                                <div class="right_bg2"></div> -->
                            </div>
                        </div>
                    </div>
                    <div>
                        <img src="http://p1.fishqc.net/FnCkrONXVNf3zvVJKYlPv-qwLNth" style="margin:90px  auto 28px;display: block;">
                        <div style="position: relative;width:1012px;margin:0 auto;">
                            <img src="http://p1.fishqc.net/Fl5FxHdf5b24L29bl0KBzkV96AYK" style="margin:0 auto;display: block;z-index: 2;position: relative;">
                            <!-- <div class="left_bg3"></div>
                            <div class="right_bg3"></div> -->
                        </div>
                        <div style="position: relative;width:1071px;margin:78px auto 0;">
                            <img src="http://p1.fishqc.net/FlgeHFw-9-i09XbaVs-yMpQLeUYB" style="margin:0 auto;display: block;z-index: 2;position: relative;">
                            <!-- <div class="left_bg4"></div>
                            <div class="right_bg4"></div> -->
                        </div>
                        <!-- <img src="http://p1.fishqc.net/FpyDahI9PfzHjF1rczfaOp2rkY8l" style="margin:30px auto 0;display: block;"> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
.about_menu_top {
    margin: 100px auto 0;

}
.fangyicontain {
    font-size: 0;
}

.vertival_align_middle {
    vertical-align: middle;
}

.display_flex {
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
}

/*.display_flex > *{
     display: block;
 }*/
.display_inline-flex {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: -webkit-inline-flex;
    display: inline-flex;
}


/*伸縮流方向*/
.flex-direction_column {
    -webkit-box-orient: vertical;
    -ms-flex-direction: column;
    -webkit-flex-direction: column;
    flex-direction: column;
}

/*主軸對齊*/
.justify-content_flex-center {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
}

.justify-content_flex-end {
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    -webkit-justify-content: flex-end;
    justify-content: flex-end;
}

.justify-content_flex-justify {
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: space-between;
}

/*側軸對齊*/
.align-items_flex-start {
    -webkit-box-align: start;
    -ms-flex-align: start;
    -webkit-align-items: flex-start;
    align-items: flex-start;
}

.align-items_flex-end {
    -webkit-box-align: end;
    -ms-flex-align: end;
    -webkit-align-items: flex-end;
    align-items: flex-end;
}

.align-items_center {
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
}

.align-items_baseline {
    -webkit-box-align: baseline;
    -ms-flex-align: baseline;
    -webkit-align-items: baseline;
    align-items: baseline;
}

.align-items_space_between {
    -webkit-box-align: space-between;
    -ms-flex-align: space-between;
    -webkit-align-items: space-between;
    align-items: space-between;
}

.horizontal-between {
    justify-content: space-between;
    -webkit-justify-content: space-between;
}

/*伸縮性*/
.flex_auto {
    -webkit-box-flex: 1;
    -ms-flex: auto;
    -webkit-flex: auto;
    flex: auto;
}

.flex_1 {
    width: 0;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    -webkit-flex: 1;
    flex: 1;
}

.flex_2 {
    width: 0;
    -webkit-box-flex: 2;
    -ms-flex: 2;
    -webkit-flex: 2;
    flex: 2;
}


.flex-wrap_wrap {
    flex-wrap: wrap;
}

.desc1 {
    width: 902px;
    font-size: 30px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #FFFFFE;
    line-height: 40px;
    text-align: left;
    margin: 26px auto 38px;

}

.box1,
.box2,
.box3 {
    width: 1000px;
    height: 408px;
    background: #B6412F;
    border-radius: 50px;
    padding: 50px 30px 50px;
    box-sizing: border-box;
    position: relative;
    z-index: 2;
}

.box_title {
    padding: 0 20px 0px;
    box-sizing: border-box;
    text-align: justify;
    font-size: 28px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 40px;

}

.padding_bottom_25 {
    padding-bottom: 32px;
    box-sizing: border-box;
}

.title_padding {
    padding: 84px 0 25px;
    box-sizing: border-box;
}

.left_bg {
    position: absolute;
    left: -304px;
    top: 0;
    width: 361px;
    height: 349px;
    background-image: url('http://p1.fishqc.net/FmXC4OgM9qVQGkfPe06YgZi3x58r');
    background-size: contain;
    background-repeat: no-repeat;
    z-index: 1
}

.right_bg {
    position: absolute;
    right: -224px;
    top: -80px;
    width: 457px;
    height: 554px;
    background-image: url(http://p1.fishqc.net/FrIy1r7aEfGRWVL-ByhoZBCSBQON);
    background-size: contain;
    background-repeat: no-repeat;
    z-index: 1;
}


.left_bg1 {
    position: absolute;
    left: -240px;
    top: -70px;
    width: 522px;
    height: 572px;
    background-image: url(http://p1.fishqc.net/Fot0PDG8oTgWewT2YxSwTuUXprAe);
    background-size: contain;
    background-repeat: no-repeat;
    z-index: 1;

}

.left_bg2 {
    position: absolute;
    left: -204px;
    bottom: 0;
    width: 305px;
    height: 220px;
    background-image: url('http://p1.fishqc.net/FtJFT3nczfgXq2dylsPddadutJcJ');
    background-size: contain;
    background-repeat: no-repeat;
    z-index: 1
}

.right_bg2 {
    position: absolute;
    right: -318px;
    bottom: 0px;
    width: 492px;
    height: 361px;
    background-image: url('http://p1.fishqc.net/FjXjSHKZVDzqUfw6lF3VNrI-HqKD');
    background-size: contain;
    background-repeat: no-repeat;
    z-index: 1;
}

.innerbox {
    width: 454px;
    height: 160px;
    background: #C04431;
    box-shadow: 0px 1px 8px 0px rgba(250, 124, 99, 0.43);
    border-radius: 24px;
    cursor: pointer;
}

.product_left {
    width: 153px;
    position: relative;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
}

.product_right {
    height: 100%;
    text-align: left;
    font-size: 20px;
    font-family: Source Han Sans SC;
    font-weight: bold;
    color: #FEFEFE;
    line-height: 30px;
    padding-top: 26px;
    padding-right: 24px;
    box-sizing: border-box;
    flex:1;
}

.address {

    font-size: 17px;
    font-family: Source Han Sans SC;
    font-weight: 300;
    color: #FFFFFF;
    line-height: 32px;
}

.label {
    height: 29px;
    line-height: 29px;
    background: #FFF45C;
    border-radius: 16px 0px 16px 0px;
    text-align: center;
    font-size: 16px;
    font-family: Adobe Heiti Std;
    font-weight: normal;
    color: #B6412F;
    padding: 0 14px;
    box-sizing: border-box;
}

.left_bg3 {
    position: absolute;
    left: -202px;
    bottom: -114px;
    width: 293px;
    height: 534px;
    background-image: url('http://p1.fishqc.net/FmTEsrfvZD-6d3BA66xBRNam7LE2');
    background-size: contain;
    background-repeat: no-repeat;
    z-index: 1
}

.right_bg3 {
    position: absolute;
    right: -304px;
    top: 164px;
    width: 361px;
    height: 347px;
    background-image: url('http://p1.fishqc.net/FnZceAGLeNDG6kZaoaOFnmxiEEwc');
    background-size: contain;
    background-repeat: no-repeat;
    z-index: 1;
}

.left_bg4 {
    position: absolute;
    left: -204px;
    bottom: 40px;
    width: 305px;
    height: 220px;
    background-image: url('http://p1.fishqc.net/FtJFT3nczfgXq2dylsPddadutJcJ');
    background-size: contain;
    background-repeat: no-repeat;
    z-index: 1
}

.right_bg4 {
    position: absolute;
    right: -318px;
    bottom: 36px;
    width: 492px;
    height: 361px;
    background-image: url('http://p1.fishqc.net/FjXjSHKZVDzqUfw6lF3VNrI-HqKD');
    background-size: contain;
    background-repeat: no-repeat;
    z-index: 1;
}

.totaldesc {
    font-size: 35px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 52px;
}
</style>
<script>
import Vue from 'vue'
// @ is an alias to /src
import banner from '@/components/banner.vue'
import { myMixin } from '@/mixin/mixin.js'
export default {
    name: 'about',
    components: {
        banner,
    },
    mixins: [myMixin],
    data() {
        return {
            productdata: [{

                dec: '进入冬季，精致女孩又要根据气候变化，皮肤状态以及功效需求调整护肤routine，选择绿鱼优品，安心衔接秋冬。',
                decclass: 'decclass',
                dd: {
                    '1': {
                        destext: '身体乳为皮肤补充所需的水分和养分，滋润肌肤。防止皮肤干燥缺水，',
                        destext1: '在皮肤表面形成一层保护膜，减缓肌肤水分的流失。',
                        title: '身体乳-身体肌肤保护膜',

                        product: [{
                            img: 'http://p1.fishqc.net/FjXH-WYRqeEyLRVKgu5hhqZ7K83P',
                            class: 'class1',
                            brand: "NIVEA妮维雅 ",
                            title: ' 深层润肤乳液',
                            tips: '深层滋养',
                            address: '德国',
                            type: 'cosmetic',
                            id: 'syRVqfvDqCizUwkg0irO1w',
                            height: 'heightclass1'

                        }, {
                            img: 'http://p1.fishqc.net/Ft5LhfnoVsByn7lcXxKZDvdVINtz',
                            class: 'class9',
                            brand: 'CeraVe ',
                            title: '长效保湿修复乳',
                            tips: '24H保湿',
                            address: '法国',
                            type: 'cosmetic',
                            id: 'G8DSWGQVu9-PBfLpFkvDiA',
                            height: 'heightclass1'
                        }]
                    },
                    '2': {
                        destext: '秋冬干燥寒冷，皮肤自身分泌的油脂减少，需要选择滋润度高的安全面霜，',
                        title: '面霜-滋润干燥肌肤',
                        destext1: '才能锁住水份，在皮肤表层形成保护作用。',
                        product: [{
                            img: 'http://p1.fishqc.net/FjoKlcr20gul7U_ymMadu0A0VCtq',
                            class: 'class1',
                            brand: "OLAY玉兰油 ",
                            title: ' 菁醇青春绵绒霜(空气感)',
                            tips: '六重修护',
                            address: '美国',
                            type: 'cosmetic',
                            id: 'pVkG7F4Yd-2Xg7sgf4DJEA',
                            height: 'heightclass1'

                        }, {
                            img: 'http://p1.fishqc.net/Fh-zxc21j3LeHxsvRZs9uZJQD3VC',
                            class: 'class2',
                            brand: 'CLE DE PEAU BEAUTE ',
                            title: '肌肤之钥 金致乳霜',
                            tips: '臻美奢养',
                            address: '日本',
                            type: 'cosmetic',
                            id: 'pvSTCcpvKrUdcPkn_4SYnA',
                            height: 'heightclass1'
                        }]
                    },
                    '3': {
                        destext: '相较脸部肌肤，脆弱的眼周更易流失水分，产生细纹，黑眼圈眼袋愈加明显，',
                        title: '眼霜-打造明眸亮眼',
                        destext1: '需要选择合适的眼霜，缓解眼部皮肤问题。',
                        product: [{
                            img: 'http://p1.fishqc.net/FsNp_ZLAmTfF67qXfdv5oW3kmhl0',
                            class: 'class7',
                            brand: "LA ROCHE-POSAY理肤泉 ",
                            title: ' 特安舒缓保湿眼霜',
                            tips: '敏感肌首选',
                            address: '法国',
                            type: 'cosmetic',
                            id: '0Y03-HSoEWcAcYBENRRuvA',
                            height: 'heightclass1'

                        }, {
                            img: 'http://p1.fishqc.net/FmJvbPSY41xGUT-yD0f0yvHQ1qxg',
                            class: 'class6',
                            brand: 'VICHY薇姿 ',
                            title: '温泉矿物水活润眼凝露眼霜',
                            tips: '水润双眸',
                            address: '法国',
                            type: 'cosmetic',
                            id: 'TbUwbgHVzrdHMOKzZvGYJA',
                            height: 'heightclass1'
                        }]
                    }

                },
            }
            ],
            productdata1: [{

                dec: '护肤品需要换季，精致女孩的秋冬美妆好物也需要安排起来，跟着绿鱼榜单选，安全又好看。',
                decclass: 'decclass1',
                dd: {
                    '1': {
                        destext: '琳琅满目的秋冬神仙色号怎么选，劣质口红容易诱发过敏甚至炎症，',
                        title: '口红-点缀精致妆容',
                        destext1: '要好看更要安全，认准绿鱼优品。',
                        product: [{
                            img: 'http://p1.fishqc.net/Fg2JTuksv-t7MSP9zumS1rPqqvG9!product.thumb',
                            class: 'class1',
                            brand: "LANCOME兰蔻",
                            title: ' 菁纯柔润唇膏',
                            tips: '柔润显色',
                            address: '法国',
                            type: 'cosmetic',
                            id: 'FBWAdzGcP3uOKiBnDGQAxw',
                            height: 'heightclass1'

                        }, {
                            img: 'http://p1.fishqc.net/Flg_015qFAPU_OoiEWqF8_yos1f3!product.thumb',
                            class: 'class2',
                            brand: 'CLIO珂莱欧   ',
                            title: '小黑跟烈焰丝绒唇膏',
                            tips: '人气热销',
                            address: '韩国',
                            type: 'cosmetic',
                            id: 'eoTpMQneMnD2438CLc88tg',
                            height: 'heightclass1'
                        }]
                    },
                    '2': {
                        destext: '劣质粉底液有害物质超标，可能使人体重金属中毒，',
                        title: '粉底液-无瑕底妆必备',
                        destext1: '彩妆第一步，要安全有保障认准绿鱼榜单。',
                        product: [{
                            img: 'http://p1.fishqc.net/FloUJCR5x8zEKpcI-UJ4vH27CM7K!product.thumb',
                            class: 'class4',
                            brand: "CPB肌肤之钥 ",
                            title: ' 光缎粉底液',
                            tips: '打造水光肌',
                            address: '日本',
                            type: 'cosmetic',
                            id: 'wAHW-xWjfTjU23R19a7D-Q',
                            height: 'heightclass1'

                        }, {
                            img: 'http://p1.fishqc.net/FpbP_lE07zBG3HVvUzQWP0dhi7r4!product.thumb',
                            class: 'class5',
                            brand: 'SHISEIDO资生堂 ',
                            title: '随肌应变光透粉底液',
                            tips: '清透服帖',
                            address: '日本',
                            type: 'cosmetic',
                            id: 'mengizLrxYWIVg18lngOWA',
                            height: 'heightclass1'
                        }]
                    },
                    '3': {
                        destext: '使用劣质卸妆产品不但卸不干净，还容易过敏，更有“烂脸”的风险，',
                        title: '卸妆用品-安全清洁更呵护',
                        destext1: '选择安全温和的卸妆用品，给自己更贴心的呵护。',
                        product: [{
                            img: 'http://p1.fishqc.net/FoBMCEyPkkzwsjrNYdbB9PphC_-N!product.thumb',
                            class: 'class1',
                            brand: "SHU UEMURA植村秀 ",
                            title: ' 绿茶新肌洁颜油',
                            tips: '一步卸净',
                            address: '日本',
                            type: 'cosmetic',
                            id: 'MZzspQXH1NxoM6Qyx2i9Ug',
                            height: 'heightclass1'

                        }, {
                            img: 'http://p1.fishqc.net/FlcY4GAIds5o6VBAsHScAa-aG6-l!product.thumb',
                            class: 'class2',
                            brand: 'SHU UEMURA植村秀 ',
                            title: '绿茶新肌洁颜油',
                            tips: '温和无刺激',
                            address: '日本',
                            type: 'cosmetic',
                            id: 'kXkNeCCBUYYygWCEmA1w7A',
                            height: 'heightclass1'
                        }]
                    }

                },
            }],
        }

    },
    computed: {
        swiper() {
            return this.$refs.order_report_Swiper.$swiper
        }
    },
    mounted() {
        // var position  =  this.$route.query.position
        // this.scrollTo(position)
        this.currentlang = window.localStorage.getItem("LOCALE") || 'chs'
    },
    methods: {
        scrollTo(position) {
            var that = this;
            var scroll_H;
            this.$nextTick(function() {
                if (position == 'greenrank') {
                    var d = document.getElementById("greenrank");
                    var topPos = d.offsetTop;
                    scroll_H = topPos - 110; //减去header高度
                } else {
                    scroll_H = this.$refs[position].offsetTop - 110; //减去header高度
                }
                //全局方法
                that.scrollToY(scroll_H, 1500, 'easeInOutQuint');
            })
        },
        toproductdetail(type,prdid){
            this.$router.push({
                path: '/product/'+type+'/'+prdid
            })
            
        }
    }
}
</script>